import {config as engagementNameConfig} from './common/EngagementName';
import {config as engagementUsersConfig} from './common/EngagementUsers';
import {config as returnedConfig} from './common/Returned';

import {config as startDateConfig} from './milestones/StartDate';
import {config as endDateConfig} from './milestones/EndDate';
import {config as statusConfig} from './milestones/Status';

import {config as reportReleaseDateConfig, id as reportReleaseDateId} from './keyevents/ReportReleaseDate';
import {config as partnerInvitedConfig, id as partnerInvitedId} from './keyevents/PartnerInvited';
import {config as picOnCraConfig, id as picOnCraId} from './keyevents/PicOnCra';
import {config as picOnAuditPlanConfig, id as picOnAuditPlanId} from './keyevents/PicOnAuditPlan';
import {config as eqrOnCraConfig, id as eqrOnCraId} from './keyevents/EqrOnCra';

import {config as preparerAssignmentsConfig, id as preparerAssignmentsId} from './assignments/PreparerAssignments';
import {
	config as preparerAssignmentsStatusConfig,
	id as preparerAssignmentsStatusId
} from './assignments/PreparerAssignmentsStatus';
import {config as assignmentsOverdueConfig, id as assignmentsOverdueId} from './assignments/PreparerAssignmentsOverdue';
import {config as preparerNotAssignedConfig, id as preparerNotAssignedId} from './assignments/PreparerNotAssigned';
import {config as reviewerAssignmentsConfig, id as reviewerAssignmentsId} from './assignments/ReviewerAssignments';
import {
	config as ReviewerAssignmentsStatusConfig,
	id as ReviewerAssignmentsStatusId
} from './assignments/ReviewerAssignmentsStatus';
import {
	config as ReviewerAssignmentsOverdueConfig,
	id as ReviewerAssignmentsOverdueId
} from './assignments/ReviewerAssignmentsOverdue';
import {config as ReviewerNotAssignedConfig, id as ReviewerNotAssignedId} from './assignments/ReviewerNotAssigned';

import {config as totalNotesConfig} from './notes/TotalNotesLabel';
import {config as openNotesConfig} from './notes/OpenNotes';
import {config as overdueNotesConfig} from './notes/Overdue';
import {config as byPriorityConfig} from './notes/ByPriority';

import {config as groupAuditTotalFormsConfig} from './primary/GroupAuditTotalForms';
import {config as primaryStatusConfig} from './primary/Status';
import {config as primaryOverdueConfig} from './primary/Overdue';
import {config as primaryReturnedConfig} from './primary/Returned';

import {config as totalTasksCapitalizedConfig} from './component/TotalTasksCapitalized';
import {config as groupAuditNotSentConfig} from './component/GroupAuditNotSent';
import {config as componentStatusConfig} from './component/Status';
import {config as groupAuditUnlinkedConfig} from './component/GroupAuditUnlinked';

import {config as groupRoleConfig, id as groupRoleId} from './insights/common/GroupRole';
import {config as totalRisksConfig} from './insights/Risks/TotalRisks';
import {config as byTypeConfig} from './insights/Risks/ByType';
import {config as digitalAuditConfig, id as digitalAuditId} from './insights/Strategy/DigitalAudit';
import {config as controlsConfig, id as controlsId} from './insights/Strategy/Controls';
import {config as substantiveConfig, id as substantiveId} from './insights/Strategy/Substantive';
import {config as itConfig, id as itId} from './insights/Strategy/IT';
import {config as misstatementsConfig} from './insights/Findings/Misstatements';
import {config as deficienciesConfig} from './insights/Findings/Deficiencies';

import {config as yearEndDateConfig, id as yearEndDateId} from './reporting/Reporting/YearEndDate';
import {
	config as endDateOfPeriodCoveredConfig,
	id as endDateOfPeriodCoveredId
} from './reporting/Reporting/EndDateOfPeriodCovered';
import {config as reportDateConfig, id as reportDateId} from './reporting/Reporting/ReportDate';
import {config as archiveDeadlineConfig, id as archiveDeadlineId} from './reporting/Reporting/ArchiveDeadline';
import {config as reportTypeConfig, id as reportTypeId} from './reporting/Reporting/ReportType';
import {config as reportingTaskStatusConfig, id as taskStatusId} from './reporting/Reporting/TaskStatus';
import {config as geographyConfig} from './reporting/Geography/Geography';
import {config as standardsConfig} from './reporting/Geography/Standards';
import {config as gaapConfig} from './reporting/Geography/Gaap';
import {config as taskStatusConfig} from './reporting/Geography/TaskStatus';

import {config as requestsConfig} from './ccp/Requests';
import {config as comingDueConfig} from './ccp/ComingDue';
import {config as overdueConfig} from './ccp/Overdue';
import {config as ccpStatusConfig} from './ccp/Status';

export const keyEventsCustomizeIds = {
	reportReleaseDateId,
	partnerInvitedId,
	picOnCraId,
	picOnAuditPlanId,
	eqrOnCraId
};

export const assignmentsCustomizeIds = {
	preparerAssignmentsId,
	preparerAssignmentsStatusId,
	assignmentsOverdueId,
	preparerNotAssignedId,
	reviewerAssignmentsId,
	ReviewerAssignmentsStatusId,
	ReviewerAssignmentsOverdueId,
	ReviewerNotAssignedId
};

export const strategyCustomizeIds = {
	digitalAuditId,
	groupRoleId,
	substantiveId,
	controlsId,
	itId
};

export const reportingCustomizeIds = {
	yearEndDateId,
	endDateOfPeriodCoveredId,
	reportDateId,
	archiveDeadlineId,
	reportTypeId,
	taskStatusId
};

export default (labels, columnVisibility, userPreferences) => {
	const engagementNameColumn = engagementNameConfig(labels);
	const engagementUsersColumn = engagementUsersConfig();

	const milestones = [
		engagementNameColumn,
		startDateConfig(labels),
		endDateConfig(labels),
		statusConfig(labels),
		engagementUsersColumn
	];

	const keyevents = [engagementNameColumn];
	if (columnVisibility.includes(keyEventsCustomizeIds.reportReleaseDateId))
		keyevents.push(reportReleaseDateConfig(labels));
	if (columnVisibility.includes(keyEventsCustomizeIds.partnerInvitedId)) keyevents.push(partnerInvitedConfig(labels));
	if (columnVisibility.includes(keyEventsCustomizeIds.picOnCraId)) keyevents.push(picOnCraConfig(labels));
	if (columnVisibility.includes(keyEventsCustomizeIds.picOnAuditPlanId)) keyevents.push(picOnAuditPlanConfig(labels));
	if (columnVisibility.includes(keyEventsCustomizeIds.eqrOnCraId)) keyevents.push(eqrOnCraConfig(labels));
	keyevents.push(engagementUsersColumn);

	const assignments = [engagementNameColumn];
	if (columnVisibility.includes(assignmentsCustomizeIds.preparerAssignmentsId))
		assignments.push(preparerAssignmentsConfig(labels));
	if (columnVisibility.includes(assignmentsCustomizeIds.preparerAssignmentsStatusId))
		assignments.push(preparerAssignmentsStatusConfig(labels));
	if (columnVisibility.includes(assignmentsCustomizeIds.assignmentsOverdueId))
		assignments.push(assignmentsOverdueConfig(labels));
	if (columnVisibility.includes(assignmentsCustomizeIds.preparerNotAssignedId))
		assignments.push(preparerNotAssignedConfig(labels));
	if (columnVisibility.includes(assignmentsCustomizeIds.reviewerAssignmentsId))
		assignments.push(reviewerAssignmentsConfig(labels));
	if (columnVisibility.includes(assignmentsCustomizeIds.ReviewerAssignmentsStatusId))
		assignments.push(ReviewerAssignmentsStatusConfig(labels));
	if (columnVisibility.includes(assignmentsCustomizeIds.ReviewerAssignmentsOverdueId))
		assignments.push(ReviewerAssignmentsOverdueConfig(labels));
	if (columnVisibility.includes(assignmentsCustomizeIds.ReviewerNotAssignedId))
		assignments.push(ReviewerNotAssignedConfig(labels));
	assignments.push(engagementUsersColumn);

	const notes = [
		engagementNameColumn,
		totalNotesConfig(labels),
		openNotesConfig(labels),
		overdueNotesConfig(labels),
		byPriorityConfig(labels),
		engagementUsersColumn
	];

	const primary = [
		engagementNameColumn,
		groupAuditTotalFormsConfig(labels),
		primaryStatusConfig(labels),
		primaryOverdueConfig(labels),
		primaryReturnedConfig(labels)
	];

	const component = [
		engagementNameColumn,
		totalTasksCapitalizedConfig(labels),
		groupAuditNotSentConfig(labels),
		componentStatusConfig(labels),
		groupAuditUnlinkedConfig(labels)
	];

	const risks = [
		engagementNameColumn,
		groupRoleConfig(labels),
		totalRisksConfig(labels),
		byTypeConfig(labels, userPreferences)
	];

	const strategy = [engagementNameColumn];
	if (columnVisibility.includes(strategyCustomizeIds.digitalAuditId)) strategy.push(digitalAuditConfig(labels));
	if (columnVisibility.includes(strategyCustomizeIds.groupRoleId)) strategy.push(groupRoleConfig(labels));
	if (columnVisibility.includes(strategyCustomizeIds.substantiveId)) strategy.push(substantiveConfig(labels));
	if (columnVisibility.includes(strategyCustomizeIds.controlsId)) strategy.push(controlsConfig(labels));
	if (columnVisibility.includes(strategyCustomizeIds.itId)) strategy.push(itConfig(labels, userPreferences));
	strategy.push(engagementUsersColumn);

	const findings = [
		engagementNameColumn,
		groupRoleConfig(labels),
		misstatementsConfig(labels),
		deficienciesConfig(labels)
	];

	const reporting = [engagementNameColumn];
	if (columnVisibility.includes(reportingCustomizeIds.yearEndDateId)) reporting.push(yearEndDateConfig(labels));
	if (columnVisibility.includes(reportingCustomizeIds.endDateOfPeriodCoveredId))
		reporting.push(endDateOfPeriodCoveredConfig(labels));
	if (columnVisibility.includes(reportingCustomizeIds.reportDateId)) reporting.push(reportDateConfig(labels));
	if (columnVisibility.includes(reportingCustomizeIds.archiveDeadlineId)) reporting.push(archiveDeadlineConfig(labels));
	if (columnVisibility.includes(reportingCustomizeIds.reportTypeId)) reporting.push(reportTypeConfig(labels));
	if (columnVisibility.includes(reportingCustomizeIds.taskStatusId))
		reporting.push(reportingTaskStatusConfig(labels, userPreferences));
	reporting.push(engagementUsersColumn);

	const geography = [
		engagementNameColumn,
		geographyConfig(labels),
		standardsConfig(labels),
		gaapConfig(labels),
		taskStatusConfig(labels),
		engagementUsersColumn
	];

	const ccp = [
		engagementNameColumn,
		requestsConfig(labels),
		ccpStatusConfig(labels),
		comingDueConfig(labels),
		overdueConfig(labels),
		returnedConfig(labels),
		engagementUsersColumn
	];

	return {
		milestones,
		keyevents,
		assignments,
		notes,
		primary,
		component,
		ccp,
		risks,
		strategy,
		findings,
		reporting,
		geography
	};
};
